export default __webpack_public_path__ + "static/media/SJA1490.34I-42075_-25221_0.34aff3cd.jpg";